import React, { Component } from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom'
import './App.css';

//Componentes
import FormComplain from './views/FormComplain/FormComplain'
import Complain from './views/Complain/Complain'
import ComplainTable from './views/ComplainTable/ComplainTable'
import ComplainsByClient from './views/ComplainsByClient/ComplainsByClient'
import Login from './components/Login/Login'

class App extends Component {
  render() {
    return (
      <Router>
        <div>
            <Route exact path="/Registro" component={FormComplain}/>
            <Route exact path="/Queja" component={Complain}/>
            <Route exact path="/Cliente" component={ComplainsByClient}/>
            <Route exact path="/Quejas" component={ComplainTable}/>
            <Route exact path="/Login" component={Login}/>
            <Route exact path="/" component={FormComplain}/>
        </div>
      </Router>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js